import React, { useRef, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import { blueGrey, grey } from "@material-ui/core/colors";
import {
  Button,
  CircularProgress,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  Typography,
  Paper,
  Divider,
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import avatarMale from "./../../images/avatar-male.jpg";
import { useSelector, useDispatch } from "react-redux";
import { getEntregador } from "../../state/entregador/actions";
import { red } from "@material-ui/core/colors";
import AlertaCodigoRetiradaModal from "./Details/AlertaCodigoRetiradaModal";
import { salesChannelIsMarketplaceOut, salesChannelIsRappi } from "../../utils/check-sales-channel";
import { checkDeliveryFromPackk } from "../../utils/check-delivery-from-packk";
import dayjs from "dayjs";
import { GerarTokenRappi } from "./CodigoRetirada/GerarTokenRappi";

const useStyles = makeStyles((theme) => ({
  buttonSave: {
    paddingTop: 8,
    paddingBottom: 8,
    marginLeft: 16,
    backgroundColor: blueGrey[800],
  },
  listContent: {
    borderBottom: `1px solid ${grey[200]}`,
    borderTop: `1px solid ${grey[200]}`,
    maxHeight: "50vh",
    minWidth: 380,
    width: 600,
    minHeight: 130,
  },
  spacingBottom: {
    marginBottom: theme.spacing(2),
  },
  action: {
    padding: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  error: {
    color: red[500],
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  avatar: {
    padding: theme.spacing(1),
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    minHeight: 106,
    "& > img": {
      width: 90,
      display: "block",
    },
  },
  dadosMotoboy: {
    paddingTop: theme.spacing(2),
  },
  contentProgress: {
    textAlign: "center",
    paddingTop: theme.spacing(3),
  },
  divider: {
    marginTop: '24px',
    marginBottom: '24px',
  }
}));

export default function CodigoRetiradaModal(props) {
  const {
    open,
    loading,
    handleClose,
    handleSelect,
    err,
    serverErr,
    codigoEntrega,
    tipoEntrega,
    erpOrigem,
    codigoExterno,
    notaFiscal,
    idPedido,
    canalDeVendas,
    printRef,
    newPrintReceipt,
    handshakeRappi,
  } = props;
  const [codigo, setCodigo] = React.useState("");
  const { entregador, loaded, error, errorData } = useSelector(
    (state) => state.entregador
  );
  const classes = useStyles();
  const dispatch = useDispatch();


  const getEntregadorFetch = React.useCallback(async () => {
    if (codigoExterno && checkDeliveryFromPackk(erpOrigem)) {
      await dispatch(getEntregador({ codigoExterno }));
    }
  }, [dispatch, codigoEntrega, tipoEntrega, codigoExterno, erpOrigem]);

  React.useEffect(() => {
    getEntregadorFetch();
  }, [getEntregadorFetch]);

  const [retrying, setRetrying] = React.useState(false);

  const retry = async () => {
    setRetrying(true);
    await getEntregadorFetch();
    setRetrying(false);
  };

  const renderError = () => (
    <>
      {retrying && renderProgress()}
      {!retrying && (
        <DialogTitle>
          <Box flexGrow={1} align="center" className={classes.spacingBottom}>
            <Typography variant="body2" className={classes.error}>
              {errorData && errorData.message
                ? errorData.message
                : "Erro ao carregar os dados do motoboy."}
            </Typography>
            {error && (
              <Box align="center">
                <Button
                  variant="outlined"
                  onClick={retry}
                  size="small"
                  color="default"
                  disableElevation
                >
                  Tentar novamente
                </Button>
              </Box>
            )}
          </Box>
        </DialogTitle>
      )}
    </>
  );

  const renderEntregador = () => (
    <DialogTitle>
      <Box flexGrow={1} display="flex" p={0}>
        <Box>
          <Paper className={classes.avatar}>
            <img
              src={
                entregador.base64ImagemSelfie
                  ? entregador.base64ImagemSelfie
                  : avatarMale
              }
              alt="Entregador"
            />
          </Paper>
        </Box>
        <Box flexGrow={1} className={classes.dadosMotoboy}>
          <Typography>
            <b>{entregador.nome}</b>
          </Typography>
          <Typography>
            <b>CPF:</b> {entregador.cpf}
          </Typography>
          <Typography>
            <b>Qtd Entregas:</b> {entregador.totalEntregas}
          </Typography>
        </Box>
      </Box>
    </DialogTitle>
  );

  const renderProgress = () => (
    <Box flexGrow={1} className={classes.contentProgress}>
      <Typography variant="body2" className={classes.spacingBottom}>
        Aguarde, carregando os dados do motoboy
      </Typography>
      <CircularProgress size={32} color="primary" />
      <div className={classes.spacingBottom}></div>
    </Box>
  );

  const handleCloseModal = () => {
    setCodigo("");
    handleClose();
  }

  const errorOccurred = error || (loaded && !entregador.cpf);
  const isRappiOrder = salesChannelIsRappi(erpOrigem);
  const isRappiTokenGenerated = isRappiOrder && handshakeRappi;

  return (
    <>
      <Dialog open={open} onClose={handleCloseModal}>
        {tipoEntrega === "EXTERNA" &&
          (errorOccurred
            ? renderError()
            : loaded
              ? renderEntregador()
              : renderProgress())}

        <DialogContent className={classes.listContent}>
          <Box flexGrow={1}>
            {isRappiOrder && <GerarTokenRappi
              dateDeExpiracao={handshakeRappi?.dataExpiracao}
              tentativasDeValidacao={handshakeRappi?.tentativasValidacao}
              tokenJaGerado={isRappiTokenGenerated}
              codigoExterno={codigoExterno}
            />}
            {isRappiOrder && <Divider className={classes.divider} />}
            <Box
              flexGrow={1}
              display="flex"
              p={0}
              className={classes.spacingBottom}
            >
              <Box flexGrow={1}>
                <Typography variant="subtitle1">
                  Confirme o código de retirada
                </Typography>
              </Box>
            </Box>
            <Box
              flexGrow={1}
              display="flex"
              p={0}
              className={classes.spacingBottom}
            >
              <Box flexGrow={1}>
                <TextField
                  disabled={loading || retrying || (isRappiOrder && !isRappiTokenGenerated)}
                  label="Código de retirada"
                  fullWidth
                  value={codigo}
                  onChange={(e) => setCodigo(e.target.value)}
                  variant="outlined"
                  size="small"
                  error={err}
                  helperText={
                    err
                      ? serverErr
                        ? `Ocorreu algum erro na verificação, código de erro: ${serverErr}`
                        : "Código incorreto"
                      : ""
                  }
                />
              </Box>
              <Box>
                <Tooltip title="Validar código" placement="top">
                  <>
                  <Button
                    disabled={loading || retrying || (isRappiOrder && !isRappiTokenGenerated)}
                    className={classes.buttonSave}
                    color="primary"
                    variant="contained"
                    aria-label="salvar"
                    disableElevation
                    onClick={() => handleSelect(codigo)}
                  >
                    {loading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      <CheckIcon />
                    )}
                  </Button>
                  </>
                </Tooltip>
              </Box>
            </Box>
            {canalDeVendas && salesChannelIsMarketplaceOut(erpOrigem) &&
              <>
                <Divider className={classes.divider} />
                <Box>
                  <AlertaCodigoRetiradaModal
                    canalDeVendas={canalDeVendas}
                    notaFiscal={notaFiscal}
                    idPedido={idPedido}
                    printRef={printRef}
                    newPrintReceipt={newPrintReceipt}
                  />
                </Box>
              </>
            }
          </Box>
        </DialogContent>
        <DialogActions className={classes.action}>
          <Box flexGrow={1} display="flex" p={0}>
            <Box flexGrow={1}>
              <Button onClick={handleCloseModal} color="inherit">
                Fechar
              </Button>
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
}
